$(function(){
  $('.js-more-link').on('click', function(e) {
    let $this = $(this);
    let $parrentBlock = $this.closest('.js-more-block');

    if ($this.hasClass('is-active')) {
      $this.removeClass('is-active').text('Читать далее');
      $parrentBlock.removeClass('is-full');
    }
    else {
      $this.addClass('is-active').text('Скрыть');
      $parrentBlock.addClass('is-full');
    }
  });
});
